// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__PoFLJ","label":"Input_label__LVoEC","input":"Input_input__7MolX","bordered":"Input_bordered__YpbZi","error":"Input_error__TswCG"};